
// @ts-nocheck


export const localeCodes =  [
  "fr-FR",
  "en",
  "en-GB",
  "en-US"
]

export const localeLoaders = {
  "fr-FR": [
    {
      key: "locale_fr_45FR_46ts_93547377",
      load: () => import("#nuxt-i18n/93547377" /* webpackChunkName: "locale_fr_45FR_46ts_93547377" */),
      cache: false
    }
  ],
  en: [
    {
      key: "locale_en_46ts_d02582d8",
      load: () => import("#nuxt-i18n/d02582d8" /* webpackChunkName: "locale_en_46ts_d02582d8" */),
      cache: false
    },
    {
      key: "locale_en_45US_46ts_053df6c2",
      load: () => import("#nuxt-i18n/053df6c2" /* webpackChunkName: "locale_en_45US_46ts_053df6c2" */),
      cache: false
    },
    {
      key: "locale_en_45GB_46ts_32e1441f",
      load: () => import("#nuxt-i18n/32e1441f" /* webpackChunkName: "locale_en_45GB_46ts_32e1441f" */),
      cache: false
    }
  ],
  "en-GB": [
    {
      key: "locale_en_46ts_d02582d8",
      load: () => import("#nuxt-i18n/d02582d8" /* webpackChunkName: "locale_en_46ts_d02582d8" */),
      cache: false
    },
    {
      key: "locale_en_45GB_46ts_32e1441f",
      load: () => import("#nuxt-i18n/32e1441f" /* webpackChunkName: "locale_en_45GB_46ts_32e1441f" */),
      cache: false
    }
  ],
  "en-US": [
    {
      key: "locale_en_46ts_d02582d8",
      load: () => import("#nuxt-i18n/d02582d8" /* webpackChunkName: "locale_en_46ts_d02582d8" */),
      cache: false
    },
    {
      key: "locale_en_45US_46ts_053df6c2",
      load: () => import("#nuxt-i18n/053df6c2" /* webpackChunkName: "locale_en_45US_46ts_053df6c2" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/030c2d0c" /* webpackChunkName: "config_i18n_46config_46ts_030c2d0c" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "fr-FR",
      files: [
        {
          path: "/vercel/path0/apps/zefire-spa/i18n/locales/fr-FR.ts",
          cache: undefined
        }
      ],
      name: "Français (FR)"
    },
    {
      code: "en",
      files: [
        {
          path: "/vercel/path0/apps/zefire-spa/i18n/locales/en.ts",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/zefire-spa/i18n/locales/en-US.ts",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/zefire-spa/i18n/locales/en-GB.ts",
          cache: undefined
        }
      ],
      name: "English"
    },
    {
      code: "en-GB",
      files: [
        {
          path: "/vercel/path0/apps/zefire-spa/i18n/locales/en.ts",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/zefire-spa/i18n/locales/en-GB.ts",
          cache: undefined
        }
      ],
      name: "English (UK)"
    },
    {
      code: "en-US",
      files: [
        {
          path: "/vercel/path0/apps/zefire-spa/i18n/locales/en.ts",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/zefire-spa/i18n/locales/en-US.ts",
          cache: undefined
        }
      ],
      name: "English (US)"
    }
  ],
  defaultLocale: "fr-FR",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "language",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "fr-FR",
    files: [
      {
        path: "/vercel/path0/apps/zefire-spa/i18n/locales/fr-FR.ts",
        cache: undefined
      }
    ],
    name: "Français (FR)"
  },
  {
    code: "en",
    files: [
      {
        path: "/vercel/path0/apps/zefire-spa/i18n/locales/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/zefire-spa/i18n/locales/en-US.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/zefire-spa/i18n/locales/en-GB.ts",
        cache: undefined
      }
    ],
    name: "English"
  },
  {
    code: "en-GB",
    files: [
      {
        path: "/vercel/path0/apps/zefire-spa/i18n/locales/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/zefire-spa/i18n/locales/en-GB.ts",
        cache: undefined
      }
    ],
    name: "English (UK)"
  },
  {
    code: "en-US",
    files: [
      {
        path: "/vercel/path0/apps/zefire-spa/i18n/locales/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/zefire-spa/i18n/locales/en-US.ts",
        cache: undefined
      }
    ],
    name: "English (US)"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/